export default __webpack_public_path__ + "static/13-19b29c2f96f39575e7d13d88efcf1f05.png";